import { validate, ValidationType } from '@/constants/regex';

export interface ValidationResult {
  isValid: boolean;
  message: string;
}

export const validateField = (type: ValidationType, value: string): ValidationResult => {
  const isValid = validate(type, value);

  const message = isValid ? '' : getErrorMessage(type);

  return {
    isValid,
    message,
  };
};

export const getErrorMessage = (type: ValidationType): string => {
  switch (type) {
    case 'phone':
      return '올바른 휴대폰 번호를 입력해주세요.';
    case 'email':
      return '올바른 이메일 주소를 입력해주세요.';
    default:
      return '올바른 형식으로 입력해주세요.';
  }
};

export const validateFileUpload = (files: File[], uploadedFiles: File[], addedUploadedFiles: File[]): boolean => {
  const maxFiles = 10;
  const maxFileSize = 5 * 1024 * 1024;

  if (files.length > maxFiles || addedUploadedFiles.length + files.length > maxFiles) {
    alert(`최대 ${maxFiles}개까지 업로드 가능합니다.`);
    return false;
  }

  const isOver5MB = files.some(file => file.size > maxFileSize);
  if (isOver5MB) {
    alert(`파일 크기가 ${maxFileSize / (1024 * 1024)}MB를 초과합니다.`);
    return false;
  }
  const duplicateFiles = files.filter(file => uploadedFiles.some(uploadedFile => uploadedFile.name === file.name));
  const isAddedUploadedFiles = addedUploadedFiles.some(file => file.name === files[0].name);
  if (duplicateFiles.length > 0 || isAddedUploadedFiles) {
    alert('이미 첨부된 파일입니다.');
    return false;
  }

  return true;
};

// 빈 문자열과 양의 정수만 가능
export const validateCount = (value: string): boolean => {
  if (value === '' || (/^\d+$/.test(value) && parseInt(value) > 0)) {
    return true;
  }
  return false;
};
